import item1DI from "../images/di-item1.png";
import item2DI from "../images/di-item2.png";
import item3DI from "../images/di-item3.png";
import item4DI from "../images/di-item4.png";

function Section5() {
  return (
    <div className="bg-[#393939] text-white font-montserrat py-12 md:py-20 md:py-32">
      <div className="flex flex-col gap-8 md:gap-12 px-6">
        <div className="color-text text-center text-[39px] md:text-5xl xl:text-[72px] leading-[1.3]">
          Our Impact on the <br />
          Community
        </div>
        <div className="max-w-7xl mx-auto text-center text-[22px] md:text-[28px] leading-[1.7]">
          Double Your Impact worked with many San Antonio organizations to
          accomplish some amazing things. With your continued support, we are
          just getting started!
        </div>
        <div className="flex flex-wrap justify-between w-[65%] mx-auto max-md:w-full pt-4">
          {/* Item 1 */}
          <div className="basis-[calc(50%-30px)] m-2 text-center max-md:basis-[85%] max-md:mx-auto">
            <img
              src={item1DI}
              alt="Food Bank Double Impact"
              className="w-full rounded-[50px] md:rounded-[64px] xl:rounded-[86px] border-[6px] border-[#FEB725]"
            />
            <div className="w-[75%] mx-auto mt-5 mb-8 text-[clamp(1rem,1.5vw,32px)] max-md:w-[90%] max-md:text-[6vw]">
              You helped deliver
              <br />
              <span className="text-primary color-text font-bold">
                392 nutritious meals
              </span>{" "}
              to seniors with Meals on Wheels.
            </div>
          </div>

          {/* Item 2 */}
          <div className="basis-[calc(50%-30px)] m-2 text-center max-md:basis-[85%] max-md:mx-auto">
            <img
              src={item2DI}
              alt="plants Double Impact"
              className="w-full rounded-[50px] md:rounded-[64px] xl:rounded-[86px] border-[6px] border-[#FEB725]"
            />
            <div className="w-[75%] mx-auto mt-5 mb-8 text-[clamp(1rem,1.5vw,32px)] max-md:w-[90%] max-md:text-[6vw]">
              You donated
              <br />
              <span className="text-primary color-text font-bold">
                83,645 meals
                <br />
              </span>
              to the San Antonio Food Bank.
            </div>
          </div>

          {/* Item 3 */}
          <div className="basis-[calc(50%-30px)] m-2 text-center max-md:basis-[85%] max-md:mx-auto">
            <img
              src={item3DI}
              alt="School Double Impact"
              className="w-full rounded-[50px] md:rounded-[64px] xl:rounded-[86px] border-[6px] border-[#FEB725]"
            />
            <div className="w-[75%] mx-auto mt-5 mb-8 text-[clamp(1rem,1.5vw,32px)] max-md:w-[90%] max-md:text-[6vw]">
              You helped raise
              <br />
              <span className="text-primary color-text font-bold">
                over $33k of School Supplies.
              </span>
            </div>
          </div>

          {/* Item 4 */}
          <div className="basis-[calc(50%-30px)] m-2 text-center max-md:basis-[85%] max-md:mx-auto">
            <img
              src={item4DI}
              alt="Animal Defense Double Impact"
              className="w-full rounded-[50px] md:rounded-[64px] xl:rounded-[86px] border-[6px] border-[#FEB725]"
            />
            <div className="w-[75%] mx-auto mt-5 mb-8 text-[clamp(1rem,1.5vw,32px)] max-md:w-[90%] max-md:text-[6vw]">
              You helped donate
              <br />
              <span className="text-primary color-text font-bold">$9,190 </span>
              to the Kerr County Relief Fund.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section5;
